"use client";
import { jsx } from 'react/jsx-runtime';
import { debug, createExperience, validateExperienceBuilderConfig, VisualEditorMode } from '@contentful/experiences-core';
import { PreviewDeliveryRoot } from './blocks/preview/PreviewDeliveryRoot.js';
import { VisualEditorRoot } from './blocks/editor/VisualEditorRoot.js';
import { useDetectCanvasMode } from './hooks/useDetectCanvasMode.js';
import { StudioCanvasMode } from '@contentful/experiences-core/constants';

const ExperienceRoot = ({ locale, experience, visualEditorMode = VisualEditorMode.LazyLoad, debug: debug$1, }) => {
    const mode = useDetectCanvasMode();
    if (typeof debug$1 === 'boolean') {
        debug.setEnabled(debug$1);
    }
    //If experience is passed in as a JSON string, recreate it to an experience object
    const experienceObject = typeof experience === 'string' ? createExperience(experience) : experience;
    validateExperienceBuilderConfig({
        locale,
        mode,
    });
    if (mode === StudioCanvasMode.EDITOR || mode === StudioCanvasMode.READ_ONLY) {
        return (jsx(VisualEditorRoot, { experience: experienceObject, visualEditorMode: visualEditorMode, initialLocale: locale }));
    }
    if (!experienceObject)
        return null;
    return jsx(PreviewDeliveryRoot, { locale: locale, experience: experienceObject });
};

export { ExperienceRoot };
//# sourceMappingURL=ExperienceRoot.js.map
